module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAUCAYAAAC9BQwsAAAAAXNSR0IArs4c6QAAAPhJREFUOE/tVKFOA1EQnCGpQuH5AGxTj+FeAoImNVV1JXXA7RmKaEUr2oree2ltcSgMCQhI7mH4ASwfgEdVLynXEsq9EASyT87sJPtmZ5cIvNhGtwT3F5RCn5342s8yhoSSRg8gDz851Ueb+KONcOnAxpzciP9NTpyaOxLHeeJw75KsWoicpOYcQHlFKKEEIgC7S+xNAU9d6+6FrValtL23cw2yHgp8AVO9mb++N77+KKmZgWj+KlZc2SQ7KZiT2Gii4GlIrNCpE3+24gquijVDABfrYh1Z8e3vWHAcsTUdAr38AqDrJOv/aZEXRfH44BJbgJOnQaj1DybIicxIfPGuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-down.png
// module id = 1asm
// module chunks = 1